module.exports = __webpack_public_path__ + "static/img/13.a20b21c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/2/zh/13.png
// module id = g1s1
// module chunks = 0